import { useWSModal } from "@wingspanhq/fe-component-library";
import { AddCustomFieldModal } from "./index";
import { CustomFieldResourceType } from "@wingspanhq/wingspan-api-sdk";

export const useModalAddCustomField = ({
  resourceType
}: {
  resourceType: CustomFieldResourceType;
}) => {
  const resourceTypeToPropsMap = {
    [CustomFieldResourceType.PAYEE]: {
      title: "Create custom contractor field"
    },
    [CustomFieldResourceType.LINE_ITEM]: {
      title: "Create custom line item field"
    },
    [CustomFieldResourceType.ENGAGEMENT]: {
      title: "Create custom engagement field"
    }
  };

  const { title } = resourceTypeToPropsMap[resourceType];

  return useWSModal(AddCustomFieldModal, {
    title,
    size: "S",
    allowClickOutsideToClose: true
  });
};
